import { buttonStyle } from 'lib/styles/index';
import styled, { css } from 'styled-components';
import Modal from './Modal';

const NotiModal = ({ children, closeModal, msg, fontL }) => {
  return (
    <Modal closeModal={closeModal}>
      <NotiModalBlock fontL={fontL}>
        <div className="img">{children}</div>
        <div className="msg">{msg}</div>
        <button onClick={closeModal}>확인</button>
      </NotiModalBlock>
    </Modal>
  );
};

export default NotiModal;

const NotiModalBlock = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  .img {
    font-size: 50px;
    margin-bottom: 10px;
  }

  .msg {
    font-weight: 500;
    margin-bottom: 20px;
  }

  button {
    ${buttonStyle}
    padding: 10px 20px;
  }

  ${props =>
    props.fontL &&
    css`
      font-size: 16px;
      padding: 2rem 3rem;
    `}
`;
